'use client';

import { type TheBoatDBConfigType, useConfig } from '@marine/configs';
import { Alert, Button } from 'antd';

/**
 * Shown when the list contains keys we switched off because the Pro
 * subscription lapsed. The API stamps `disabledReason` for exactly this: a dead
 * key with no explanation reads as our bug, and the fix — re-subscribe, same
 * keys come back — is not something anyone would guess.
 */
const DisabledKeysNotice: React.FC<{ disabledCount: number }> = ({ disabledCount }) => {
  const { manageSubscriptionUrl } = useConfig<TheBoatDBConfigType>();

  return (
    <Alert
      type="warning"
      showIcon
      title={`${disabledCount === 1 ? 'One key is' : `${disabledCount} keys are`} disabled`}
      description="Your Pro subscription lapsed, so these keys stopped working and requests using them return 401. Re-subscribe and the same keys are restored automatically — you do not need to issue new ones or redeploy."
      action={
        manageSubscriptionUrl === undefined ? undefined : (
          <Button size="small" color="primary" variant="solid" href={manageSubscriptionUrl}>
            Restore subscription
          </Button>
        )
      }
    />
  );
};

export { DisabledKeysNotice };
